import { Box, Flex, List, Text } from '@chakra-ui/react'
import { useFormikContext } from 'formik'
import { PropsWithChildren } from 'react'
import { FormFooter } from './FormFooter'

/** Собирает все строки ошибок из дерева Formik (вложенные объекты, массивы полей). */
function flattenFormErrors(errors: unknown): string[] {
  if (errors == null || errors === '') {
    return []
  }
  if (typeof errors === 'string') {
    return [errors]
  }
  if (Array.isArray(errors)) {
    return errors.flatMap((item) => flattenFormErrors(item))
  }
  if (typeof errors === 'object') {
    return Object.values(errors).flatMap((item) => flattenFormErrors(item))
  }
  return []
}

interface FormProps extends PropsWithChildren {
  footer?: React.ReactNode
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void
}

export const Form: React.FC<FormProps> = ({
  footer = null,
  children,
  onSubmit,
  ...props
}) => {
  const dataForm = useFormikContext()
  const hasError = dataForm ? !dataForm.isValid && dataForm.submitCount > 0 : false
  const errorMessages = flattenFormErrors(dataForm.errors)

  return (
    <Box {...props}>
      <form onSubmit={onSubmit}>
        {children}
        {hasError && (
          <Box pt="20px">
            <Flex alignItems="center" color="red.500" fontSize="0.87rem">
              <Text>Есть ошибки в форме:</Text>
            </Flex>
            <List.Root alignItems="flexStart" color="red.500" fontSize="0.87rem">
              {errorMessages.map((message, index) => (
                <List.Item key={index}>{message}</List.Item>
              ))}
            </List.Root>
          </Box>
        )}
        {footer && <FormFooter>{footer}</FormFooter>}
      </form>
    </Box>
  )
}
